import classNames from 'classnames'
import React from 'react'

export interface SkeletonTextLinesProps {
  /** Matches the bubble it sits in — "dark" for the sender's own bubble. */
  variant: 'light' | 'dark'
}

/**
 * Two skeleton bars standing in for the redacted text of a paid text-only
 * message — the real content is never sent to the client until purchase, so
 * there's nothing to render yet.
 *
 * Uses explicit black/white (not `bg-current`) because Tailwind doesn't
 * support opacity modifiers on the `current` color — `bg-current/30` silently
 * produces no CSS rule at all.
 */
const SkeletonTextLines: React.FC<SkeletonTextLinesProps> = ({
  variant = 'dark',
}) => {
  const colour = variant === 'dark' ? 'bg-white/25' : 'bg-black/15'

  return (
    <div
      className="flex flex-col gap-2 str-chat__message-text my-1 animate-pulse"
      aria-hidden
    >
      <div className={classNames('h-3 w-40 rounded-full', colour)} />
      <div className={classNames('h-3 w-24 rounded-full', colour)} />
    </div>
  )
}

export default SkeletonTextLines
